import { IconButton, TextField } from '@mui/material'
import React from 'react'

function DemoStep6() {
  return (
    <>
      <div className="form">
        <div className="gap_p">
          <div className="control_group">
            <h3 className='hd_6'>Social Media Links (Optional)</h3>
            <ul className="social_list">
              <li>
                <IconButton className='btn_rounded primary'><img src="/static/images/twitter_icon.svg" alt="Icon" /></IconButton>
                <TextField hiddenLabel fullWidth placeholder="Paste link here"></TextField>
              </li>
              <li>
                <IconButton className='btn_rounded primary'><img src="/static/images/facebook_icon.svg" alt="Icon" /></IconButton>
                <TextField hiddenLabel fullWidth placeholder="Paste link here"></TextField>
              </li>
              <li>
                <IconButton className='btn_rounded primary'><img src="/static/images/instagram_icon.svg" alt="Icon" /></IconButton>
                <TextField hiddenLabel fullWidth placeholder="Paste link here"></TextField>
              </li>
              <li>
                <IconButton className='btn_rounded primary'><img src="/static/images/ticktok_icon.svg" alt="Icon" /></IconButton>
                <TextField hiddenLabel fullWidth placeholder="Paste link here"></TextField>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export default DemoStep6